import { Component, Input, OnInit } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { FormGroup } from '@angular/forms';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { FLIGHT_ARRAY_FIELDS, FLIGHT_CHECKBOX_FIELDS, FLIGHT_DATE_FIELDS, FLIGHT_TEXT_FIELDS } from '../config';
import { ConfigFieldBuilderService } from '../config-field-builder.service';
import { IDateRangeOptionsConfig } from '../../date-field-set/date-field-set.component';
import { TEMPLATE_LABELS } from 'app_sasha/shared/config/booking-wording';
import { BookingSearchParameters } from 'libraries/interfaces/IBookingSearchParameters';

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'flight-fieldset',
    template: `
        <div class="sep-top">
            <collapsible class="sep-top" [title]="flightSearchTitle" [open]="open">

                <div class="col-to-row-s-tb sep-top">
                    <checkbox-field [fieldConfig]="formFields.sectorMatchAll"></checkbox-field>
                </div>

                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="formFields?.sectorFrom" [toUpper]="chipsToUpper"></chips>
                    </div>

                    <div class="flex-1 sep-top sep-left">
                        <chips [fieldConfig]="formFields?.sectorTo" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>

                <div class="col-to-row-s-tb">
                    <date-field-set
                        [form]="form"
                        [optionsConfig]="dateOptions">
                    </date-field-set>
                </div>

                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="formFields.sectorSeatStatus" [toUpper]="chipsToUpper"></chips>
                    </div>

                    <div class="flex-1 sep-top sep-left">
                        <chips [fieldConfig]="formFields.sectorFlightNumber" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>

                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="formFields.sectorCarrier" [toUpper]="chipsToUpper"></chips>
                    </div>

                    <div class="flex-1 sep-top sep-left">
                        <chips [fieldConfig]="formFields.sectorOperatingCarrier" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>
            </collapsible>
        </div>
    `
})
export class FlightFieldsetComponent implements OnInit {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @Input()
    public chipsToUpper: boolean;

    public readonly flightSearchTitle: string = Yii.t('wui-sasha-js', 'Aérien - Vols');

    public formFields: IFieldConfig;
    public dateOptions: IDateRangeOptionsConfig;

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService
    ) { }

    public ngOnInit(): void {
        this.formFields = {
            ...this.configFieldBuilderService.buildFieldConfigCheckbox(this.form, FLIGHT_CHECKBOX_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigArray(this.form, FLIGHT_ARRAY_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigDate(this.form, FLIGHT_DATE_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigCode(this.form, FLIGHT_TEXT_FIELDS),
        };

        this.dateOptions = {
            label: TEMPLATE_LABELS.dateField,
            optionConfig: FLIGHT_DATE_FIELDS
                .map((fieldName: BookingSearchParameters) => this.configFieldBuilderService.createDateRangeOptionConfig(fieldName, this.formFields))
        };
    }
}
